import { MinAndMaxDateService } from "../service/asyncMinAndMaxDateService";
import * as validations from "../utils/validations";

export class MinAndMaxDateFunctions {
  fnBurgissCalcFundingMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcFundingMaxDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcFundingMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcFundingMinDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcCashMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcCashMaxDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcCashMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcCashMinDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcFeesMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcFeesMaxDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcFeesMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcFeesMinDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcValuationMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcValuationMaxDate(investId, idType, beginDate, endDate, filter);
  }

  fnBurgissCalcValuationMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcValuationMinDate(investId, idType, beginDate, endDate, filter);
  }

  fnBurgissCalcStockMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcStockMinDate(investId, idType, beginDate, endDate, filter);
  }
  fnBurgissCalcStockMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    idType = validations.getIdType(idType);
    if (String(idType) == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    endDate = validations.isValidDate(endDate);
    endDate = new Date(endDate).toLocaleDateString();
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
      if (beginDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    return new MinAndMaxDateService().burgissCalcStockMaxDate(investId, idType, beginDate, endDate, filter);
  }
}
